export default {
  SET_LIST(state, opportunities) {
    state.list = opportunities;
  },
  SET_CURRENT_OPPORTUNITY(state, opportunity) {
    state.current_opportunity = opportunity;
  },
  SET_FUNNEL_VALUES(state, funnelValues) {
    state.funnel_values = funnelValues;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};
